<div class="frac-home-sandi-status">
  <sa-lmo-frac-home-card localStorageKey="home__storage_prediction" [isLoading]="!fracGraph">
    <header class="my-1 py-2">
      <img src="/assets/icons/sandi-wave.svg" alt="SANDi" />
      <span class="text-xl font-medium">Storage Prediction</span>
    </header>
    <main *ngIf="fracGraph && fracGraph.storages.length > 0">
      <mat-tab-group headerPosition="below">
        <mat-tab *ngFor="let storage of storages; trackBy: trackByMeshId">
          <ng-template mat-tab-label>
            <div class="label-container gap-1" [matTooltip]="lastUpdateTime(storage)">
              <div class="truck-count">+{{ storage.truckCount }}&nbsp;</div>
              {{ storage.mesh.type + ' Mesh' }}
            </div>
          </ng-template>
          <ng-template matTabContent>
            <div class="graph-container">
              <sa-lmo-current-stock-graph [fracStorage]="storage" class="graph">
                <ng-template #seriesTooltipTemplate let-model="model">
                  <div class="tooltip">
                    <div class="title">
                      <span *ngIf="!frac.completed; else completed">
                        <ng-container *ngIf="model[0]?.stage !== 0; else prefill">
                          <span class="current-stage">Stage {{ model[0]?.stage }}</span>
                          of {{ frac.totalStages }}
                        </ng-container>
                      </span>
                      <ng-template #prefill>Prefill</ng-template>
                      <ng-template #completed>Frac Completed</ng-template>
                    </div>
                    <div class="tooltip-main">
                      <section class="info-panel time-panel">
                        <div class="status okay">{{ fromNow(model[0]?.timestamp) }}</div>
                        <div class="name upper">time</div>
                      </section>

                      <section class="info-panel">
                        <div class="status okay">{{ model[0]?.stock | approxBigNumber }} Lbs</div>
                        <div class="name upper">stock</div>
                      </section>

                      <section class="info-panel">
                        <ng-container *ngIf="isBox(storage); else silo">
                          <div class="status okay">
                            {{
                              loadsToMax(storage.capacity, model[0]?.stock, storage.loadWeight) * storage.numberBoxes
                            }}
                          </div>
                          <div class="name upper">
                            {{
                              loadsToMax(storage.capacity, model[0]?.stock, storage.loadWeight) *
                                storage.numberBoxes ===
                              1
                                ? 'Empty Box'
                                : 'Empty Boxes'
                            }}
                          </div>
                        </ng-container>
                        <ng-template #silo>
                          <div class="status okay">
                            {{
                              loadsToMax(storage.capacity, model[0]?.stock, storage.loadWeight)
                                | i18nPlural: loadPluralMapping
                            }}
                          </div>
                          <div class="name upper">to max</div>
                        </ng-template>
                      </section>
                    </div>
                  </div>
                </ng-template>
              </sa-lmo-current-stock-graph>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </main>
  </sa-lmo-frac-home-card>
</div>
